import {
  FEATURE_DEFAULTS,
  FeatureVisibility,
  IFeature,
} from '@principle-theorem/feature-flags';
import { Region } from '@principle-theorem/shared';

export const PARCHMENT_FEATURE: IFeature = {
  label: 'parchment',
  visibility: FeatureVisibility.OptIn,
  permissions: [],
};

export const AI_NOTES_FEATURE: IFeature = {
  label: 'ai-notes',
  visibility: FeatureVisibility.OptIn,
  permissions: [],
};

export const VERIFONE_FEATURE: IFeature = {
  ...FEATURE_DEFAULTS,
  label: 'verifone',
  visibility: FeatureVisibility.OptIn,
  regions: [Region.NewZealand],
}

export const VIA_API_SMS_FEATURE: IFeature = {
  label: 'via-api-sms',
  visibility: FeatureVisibility.OptIn,
  permissions: [],
};

export const INTEGRATIONS_FEATURE: IFeature = {
  label: 'practices',
  visibility: FeatureVisibility.None,
  features: [PARCHMENT_FEATURE, AI_NOTES_FEATURE, VERIFONE_FEATURE, VIA_API_SMS_FEATURE],
  permissions: [],
};
